import React from 'react';

import { ShimLayerBackground } from '@vw-marketing/vw-core-components/dist/components/atoms/old-components/ShimLayer/src/ShimLayerBackground';
import {
  StyledBodyContainer,
  StyledLowerContainer,
  StyledUpperContainer,
} from './styles';
import ErrorModalComponent from '@vw-marketing/vw-core-components/dist/components/atoms/old-components/ErrorModalComponent';

interface ErrorModalProps {
  contentGap?: number;
  isActive: boolean;
  lowerContent?: React.ReactNode | string;
  title?: React.ReactNode | string;
  upperContent?: React.ReactNode | string;

  // functions
  setErrorModal: (value: boolean) => void;
}

export const ErrorModal = ({
  contentGap = 20,
  isActive,
  lowerContent,
  setErrorModal,
  title,
  upperContent,
}: ErrorModalProps) => {
  return (
    <ShimLayerBackground isActive={isActive}>
      <ErrorModalComponent
        modalType="oops"
        title={title ? title : null}
        bodyText={
          upperContent || lowerContent ? (
            <StyledBodyContainer gap={contentGap}>
              {upperContent && (
                <StyledUpperContainer>{upperContent}</StyledUpperContainer>
              )}
              {lowerContent && (
                <StyledLowerContainer>{lowerContent}</StyledLowerContainer>
              )}
            </StyledBodyContainer>
          ) : null
        }
        hideContactInfo
        buttonOnClick={() => {
          setErrorModal(!isActive);
        }}
      />
    </ShimLayerBackground>
  );
};
